import React, { useState } from 'react';

function SocialButtons ({isSmallScreen}) {
  var [instaColor, setInstaColor] = useState('#C19A6B');
  var [twtColor, setTwtColor] = useState('#C19A6B');
  var [gitColor, setGitColor] = useState('#C19A6B');
  var [whatsColor, setWhatsColor] = useState('#C19A6B');
  let iconSize='30px';
 
  
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row gap-2">
        <button className=" w-24 h-24 outline-none border-none bg-white rounded-[90px_5px_5px_5px] shadow-md transition duration-200 ease-in-out hover:scale-110 hover:bg-[#cc39a4]" onMouseEnter={()=> {setInstaColor('white')}} onMouseLeave={()=> {setInstaColor('#C19A6B')}}>
            
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 256"
            width={iconSize}
            height={iconSize}
            className="mt-6 ml-9"
            style={{fill: `${instaColor}`}}
            
          >
            <g
              fillRule="nonzero"
              stroke="none"
              strokeWidth="1"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeMiterlimit="10"
              strokeDasharray=""
              strokeDashoffset="0"
              fontFamily="none"
              fontWeight="none"
              fontSize="none"
              textAnchor="none"
              style={{ mixBlendMode: 'normal' }}
            >
              <g transform="scale(8,8)">
                <path d="M11.46875,5c-3.55078,0 -6.46875,2.91406 -6.46875,6.46875v9.0625c0,3.55078 2.91406,6.46875 6.46875,6.46875h9.0625c3.55078,0 6.46875,-2.91406 6.46875,-6.46875v-9.0625c0,-3.55078 -2.91406,-6.46875 -6.46875,-6.46875zM11.46875,7h9.0625c2.47266,0 4.46875,1.99609 4.46875,4.46875v9.0625c0,2.47266 -1.99609,4.46875 -4.46875,4.46875h-9.0625c-2.47266,0 -4.46875,-1.99609 -4.46875,-4.46875v-9.0625c0,-2.47266 1.99609,-4.46875 4.46875,-4.46875zM21.90625,9.1875c-0.50391,0 -0.90625,0.40234 -0.90625,0.90625c0,0.50391 0.40234,0.90625 0.90625,0.90625c0.50391,0 0.90625,-0.40234 0.90625,-0.90625c0,-0.50391 -0.40234,-0.90625 -0.90625,-0.90625zM16,10c-3.30078,0 -6,2.69922 -6,6c0,3.30078 2.69922,6 6,6c3.30078,0 6,-2.69922 6,-6c0,-3.30078 -2.69922,-6 -6,-6zM16,12c2.22266,0 4,1.77734 4,4c0,2.22266 -1.77734,4 -4,4c-2.22266,0 -4,-1.77734 -4,-4c0,-2.22266 1.77734,-4 4,-4z"></path>
              </g>
            </g>
          </svg>
        </button>
        <button className=" w-24 h-24 outline-none border-none bg-white rounded-[5px_90px_5px_5px] shadow-md transition duration-200 ease-in-out hover:scale-110 hover:bg-[#03A9F4]" onMouseEnter={()=> {setTwtColor('white')}} onMouseLeave={()=> {setTwtColor('#C19A6B')}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width={iconSize}
            height={iconSize}
            className="mt-6 ml-[1.65rem]"
            style={{fill: `${twtColor}`}}
          >
            <path d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"></path>
          </svg>
        </button>
      </div>
      <div className="flex flex-row gap-2">
        <button  className=" w-24 h-24 outline-none border-none bg-white rounded-[5px_5px_5px_90px] shadow-md transition duration-200 ease-in-out hover:scale-110 hover:bg-black" onMouseEnter={()=> {setGitColor('white')}} onMouseLeave={()=> {setGitColor('#C19A6B')}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width={iconSize}
            height={iconSize}
            className="mt-[-0.5rem] ml-[2.3rem]"
            style={{fill: `${gitColor}`}}
          >
            <path d="M15,3C8.373,3,3,8.373,3,15c0,5.623,3.872,10.328,9.092,11.63C12.036,26.468,12,26.28,12,26.047v-2.051 c-0.487,0-1.303,0-1.508,0c-0.821,0-1.551-0.353-1.905-1.009c-0.393-0.729-0.461-1.844-1.435-2.526 c-0.289-0.227-0.069-0.486,0.264-0.451c0.615,0.174,1.125,0.596,1.605,1.222c0.478,0.627,0.703,0.769,1.596,0.769 c0.433,0,1.081-0.025,1.691-0.121c0.328-0.833,0.895-1.6,1.588-1.962c-3.996-0.411-5.903-2.399-5.903-5.098 c0-1.162,0.495-2.286,1.336-3.233C9.053,10.647,8.706,8.73,9.435,8c1.798,0,2.885,1.166,3.146,1.481C13.477,9.174,14.461,9,15.495,9 c1.036,0,2.024,0.174,2.922,0.483C18.675,9.17,19.763,8,21.565,8c0.732,0.731,0.381,2.656,0.039,3.673 c0.834,0.948,1.332,2.065,1.332,3.232c0,2.705-1.913,4.686-5.917,5.098c1.03,0.548,1.819,2.151,1.819,3.201v3.041 c0,0.223-0.017,0.419-0.051,0.592C23.195,25.472,27,20.648,27,15C27,8.373,21.627,3,15,3z"></path>
          </svg>
        </button>
        <button  className="w-24 h-24 outline-none border-none bg-white rounded-[5px_5px_90px_5px] shadow-md transition duration-200 ease-in-out hover:scale-110 hover:bg-[#40C351]" onMouseEnter={()=> {setWhatsColor('white')}} onMouseLeave={()=> {setWhatsColor('#C19A6B')}}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
            width="25px"
            height={iconSize} className="mb-2 ml-[1.65rem]"
            style={{fill: `${whatsColor}`}}
            >
                
            <path d="M25,2C12.318,2,2,12.318,2,25c0,3.96,1.023,7.854,2.963,11.29L2.037,46.73c-0.096,0.343-0.003,0.711,0.245,0.966 C2.473,47.893,2.733,48,3,48c0.08,0,0.161-0.01,0.24-0.029l10.896-2.699C17.463,47.058,21.21,48,25,48c12.682,0,23-10.318,23-23 S37.682,2,25,2z M36.57,33.116c-0.492,1.362-2.852,2.605-3.986,2.772c-1.018,0.149-2.306,0.213-3.72-0.231 c-0.857-0.27-1.957-0.628-3.366-1.229c-5.923-2.526-9.791-8.415-10.087-8.804C15.116,25.235,13,22.463,13,19.594 s1.525-4.28,2.067-4.864c0.542-0.584,1.181-0.73,1.575-0.73s0.787,0.005,1.132,0.021c0.363,0.018,0.85-0.137,1.329,1.001 c0.492,1.168,1.673,4.037,1.819,4.33c0.148,0.292,0.246,0.633,0.05,1.022c-0.196,0.389-0.294,0.632-0.59,0.973 s-0.62,0.76-0.886,1.022c-0.296,0.291-0.603,0.606-0.259,1.19c0.344,0.584,1.529,2.493,3.285,4.039 c2.255,1.986,4.158,2.602,4.748,2.894c0.59,0.292,0.935,0.243,1.279-0.146c0.344-0.39,1.476-1.703,1.869-2.286 s0.787-0.487,1.329-0.292c0.542,0.194,3.445,1.604,4.035,1.896c0.59,0.292,0.984,0.438,1.132,0.681 C37.062,30.587,37.062,31.755,36.57,33.116z"></path>
        </svg>
          
        </button>
      </div>
    </div>
  );
};

export default SocialButtons;
